import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import SectorPage from "@/pages/SectorPage";

function App() {
  return (
    <div className="App min-h-screen bg-ax-bg font-body text-ax-text">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/setores/:slug" element={<SectorPage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors theme="dark" />
    </div>
  );
}

export default App;
